import { LayoutDashboard, Users, ClipboardList, UserCog, Settings, BarChart3 } from "lucide-react";
import DashboardLayout from "@/components/layout/DashboardLayout";

const NAV_ITEMS = [
  { to: "/doctor/dashboard", label: "Dashboard", icon: LayoutDashboard, testId: "doctor-nav-dashboard" },
  { to: "/doctor/patients", label: "Patient Management", icon: Users, testId: "doctor-nav-patients" },
  { to: "/doctor/queue", label: "Today's Queue", icon: ClipboardList, testId: "doctor-nav-queue" },
  { to: "/doctor/staff", label: "Staff Management", icon: UserCog, testId: "doctor-nav-staff" },
  { to: "/doctor/analytics", label: "Analytics", icon: BarChart3, testId: "doctor-nav-analytics" },
  { to: "/doctor/settings", label: "Clinic Settings", icon: Settings, testId: "doctor-nav-settings" },
];

export default function DoctorLayout({ children }) {
  return (
    <DashboardLayout navItems={NAV_ITEMS} roleLabel="Doctor">
      {children}
    </DashboardLayout>
  );
}
